import { Flex, SystemProps, LegacyText, Text, Stack, Box } from "flicket-ui";
import styled from "styled-components";
import { Select } from "~components";
import { SeatsIOSeat } from "~components/reservation/constants";
import { formatSeatLocation } from "~lib";
import PriceWithFee from "../../common/common.PriceWithFee";
import { ListItemDetails } from "./PricingListItemDetails";
import { StylesConfig } from "react-select";
import { useOrganization } from "~hooks";
// Line removed as it is unused.

const StyledListItem = styled(Flex)<SystemProps>`
  margin-bottom: ${(p) => p.theme.space[3]}px;

  justify-content: space-between;
  align-items: start;
`;

interface ListItemProps {
  seat: SeatsIOSeat;
  options: any[];
  handleTicketTypeChange: (id: any, newType: any) => void;
  showHiddenFees?: boolean;
}

export const ListItem = ({
  seat,
  options,
  handleTicketTypeChange,
  showHiddenFees = false,
}: ListItemProps) => {
  const { organization } = useOrganization();
  const hasTicketsAvailable = options?.length > 0;

  return (
    <StyledListItem mb={{ _: "5/4", md: 3 }} key={seat?.uuid}>
      <Stack flexDir="column" flex={1} gap={2}>
        <Box>
          <Text variant="header.XS">
            {/* don't pass zone label to avoid duplication */}
            {formatSeatLocation(undefined, seat.sectionLabel, seat.label, {
              objectType: seat.objectType,
            })}
          </Text>
          {hasTicketsAvailable && (
            <>
              <Text variant="small">
                <PriceWithFee
                  price={seat.originalPrice}
                  ticketType={seat.ticketType}
                  showFees={showHiddenFees}
                  currency={organization.currency}
                />
              </Text>
              <ListItemDetails
                name={seat?.ticketType?.label}
                description={seat?.ticketType?.description}
                restrictions={seat?.ticketType?.restrictions}
                addonImage={seat?.ticketType?.addonImage}
                ticketImage={seat?.ticketType?.ticketImage}
                ticketType={seat}
              />
            </>
          )}
        </Box>
        <Box width="100%">
          {(() => {
            if (!hasTicketsAvailable) {
              return (
                <Text variant="small" textAlign="end" mt="1/2">
                  No tickets available
                </Text>
              );
            }

            const defaultOption =
              options.find((option) => option.value === seat?.ticketType?.id) ||
              options[0];

            return (
              <Select
                options={options}
                onChange={(value) =>
                  handleTicketTypeChange(seat?.customId ?? seat.id, value)
                }
                defaultValue={{
                  label: defaultOption.label,
                  value: defaultOption.value,
                }}
                size="compact"
                selectProps={{
                  isSearchable: false,
                  styles: {
                    control: (provided) => ({
                      ...provided,
                      minHeight: "40px",
                      height: "40px",
                    }),
                  } as StylesConfig,
                }}
              />
            );
          })()}
        </Box>
      </Stack>
    </StyledListItem>
  );
};
